import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Search from "./svgs/search"
import Exit from "./svgs/exit"

const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border-radius: 50px;
  border: 0.969px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0px 3.875px 15.499px 0px rgba(0, 0, 0, 0.08);
  padding: 8px 16px;
  min-width: 300px;
  width: 100%;

  @media (max-width: 1300px) {
    width: 100%;
  }
  @media (max-width: 1200px) {
    display: none;
  }
`

const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 16px;
  color: #4a4a4a;
  padding-left: 8px !important;

  &::placeholder {
    color: #7a7a7a;
  }
`

const IconButton = styled.button`
  background-color: ${({ $bgColor }) => $bgColor || "#ddd"};
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin-left: 8px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  svg {
    color: white;
  }
`

const CloseButton = styled(IconButton)`
  background-color: #eaeaea;

  svg {
    color: #4a4a4a;
  }
`

const SearchBar = ({ placeholder, onChange, onFocus }) => {
  const [query, setQuery] = React.useState("")

  const handleClear = () => {
    onChange({
      target: {
        value: "",
      },
    })
    setQuery({
      target: {
        value: "",
      },
    })
  }
  const handleSearch = () => {
    onChange(query)
  }

  return (
    <SearchBarContainer>
      <SearchInput
        type="text"
        placeholder={placeholder}
        value={query?.target?.value}
        onChange={e => {
          onChange(e)
          setQuery(e)
        }}
        onFocus={onFocus}
      />

      {query?.target?.value && (
        <CloseButton onClick={handleClear}>
          <Exit />
        </CloseButton>
      )}

      <IconButton $bgColor="#2F4F4F" onClick={handleSearch}>
        <Search />
      </IconButton>
    </SearchBarContainer>
  )
}

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
}

export default SearchBar
